import "./signup.css";

export default function SignUpPage() {
    return <>
        <form className="signup-center-frame">
            <h2>Создание аккаунта</h2>
            <div className="signup-sides">
                <div className="signup-leftside">
                    <p>E-Mail:</p>
                    <input type="email" />
                    <p>Пароль:</p>
                    <input type="password" />
                    </div>
                <div className="signup-rightside">
                    <p>Имя будущего канала:</p>
                    <input type="text" />
                    <p>Повтор пароля:</p>
                    <input type="password" />
                </div>
            </div>
            <input type="submit" value="Создать" className="signup-btn"/>
            <p>Уже есть аккаунт? <a href="/signin">Войти</a></p>
        </form>
    </>
}